module.exports = __webpack_public_path__ + "media/images/beauty/cover-desktop@2x-1681ded8a4aacc81aed2eabd1b7360c1.jpg";